<template>
    <div>Redirecting to PTA Registration</div>
</template>

<script>
export default {
    created () {
        window.open("https://forms.gle/n6QUD41fotab1dUq5");
        this.$router.push({ path: '/dashboard'})
    }
}
</script>